module.exports = __webpack_public_path__ + "img/modelshow05-4.2d1997b7.png";